export const PRODUCT_CATEGORY_OPTIONS = [
    { value: "Beverages", label: "Beverages" },
    { value: "Snacks", label: "Snacks" },
    { value: "Food", label: "Food" },
    { value: "Frozen Foods", label: "Frozen Foods" },
    { value: "Dairy", label: "Dairy" },
    { value: "Bakery", label: "Bakery" },
    { value: "Canned Goods", label: "Canned Goods" },
    { value: "Instant Noodles", label: "Instant Noodles" },
    { value: "Condiments", label: "Condiments" },
    { value: "Cooking Essentials", label: "Cooking Essentials" },
    { value: "Rice & Grains", label: "Rice & Grains" },
    { value: "Grocery", label: "Grocery" },
    { value: "Personal Care", label: "Personal Care" },
    { value: "Health & Medicine", label: "Health & Medicine" },
    { value: "Baby Care", label: "Baby Care" },
    { value: "Household", label: "Household" },
    { value: "Cleaning Supplies", label: "Cleaning Supplies" },
    { value: "Laundry", label: "Laundry" },
    { value: "Paper & Plastic Goods", label: "Paper & Plastic Goods" },
    { value: "Pet Supplies", label: "Pet Supplies" },
    { value: "School & Office Supplies", label: "School & Office Supplies" },
    { value: "Electronics & Accessories", label: "Electronics & Accessories" },
    { value: "Tobacco", label: "Tobacco" },
    { value: "Alcohol", label: "Alcohol" },
    { value: "Load & E-Pins", label: "Load & E-Pins" },
    { value: "Bills Payment", label: "Bills Payment" },
    { value: "Ice", label: "Ice" },
    { value: "Water Refills", label: "Water Refills" },
    { value: "Candies", label: "Candies" },
    { value: "Biscuits", label: "Biscuits" },
    { value: "Coffee & Milk", label: "Coffee & Milk" },
    { value: "Cigarettes", label: "Cigarettes" },
    { value: "Toiletries", label: "Toiletries" },
    { value: "Services", label: "Services" },
    { value: "Others", label: "Others" },
];

export const PRODUCT_CATEGORY_FILTER_OPTIONS = [
    { value: "All", label: "All Categories" },
    ...PRODUCT_CATEGORY_OPTIONS,
];
